import ContextMenuController from "@/js/Webmail/ContextMenuController";

export { ContextMenuDirective as default };

const ContextMenuDirective = {
  created(el, binding) {
    el.menu_data = binding.value.data || undefined;
    el.onContextMenu = (event) => {
      event.preventDefault();
      ContextMenuController.setEvent(event);
      ContextMenuController.setTarget(el);
      binding.value.action(el.menu_data);
    }
  },

  async unmounted(el) {
    el.removeEventListener('contextmenu', el.onContextMenu);
  },

  mounted(el) {
    el.addEventListener('contextmenu', el.onContextMenu);
  },
}
